import { Button, Pill } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ReconsentConnection } from './getReconsentConnections';
import { LinkedAccount } from '../../../ui/linkedAccount/LinkedAccount';

export const ReconfirmConnections = ({
    connections,
    extendedConnectionIds,
    onExtend,
    onRevoke,
    onSkip
}: {
    connections: ReconsentConnection[];
    extendedConnectionIds: string[];
    onExtend: (connection: ReconsentConnection) => void;
    onRevoke: (connection: ReconsentConnection) => void;
    onSkip: () => void;
}) => {
    return (
        <div className="space-y-l">
            <div className="space-y-m">
                {connections.map((connection) => (
                    <div
                        key={connection.onlineAccountId}
                        data-testid="reconsent-connection-row"
                    >
                        <LinkedAccount
                            account={connection}
                            actions={
                                <>
                                    <ExtendAction
                                        connection={connection}
                                        isExtended={extendedConnectionIds.includes(
                                            connection.onlineAccountId
                                        )}
                                        onExtend={onExtend}
                                    />
                                    <Button
                                        size="small"
                                        variant="tertiary"
                                        onClick={() => onRevoke(connection)}
                                    >
                                        <FormattedMessage
                                            id="_.bank_selection_modal.reconsent.revoke"
                                            defaultMessage="Revoke"
                                        />
                                    </Button>
                                </>
                            }
                        />
                    </div>
                ))}
            </div>

            <div className="text-center">
                <Button variant="secondary" size="small" onClick={onSkip}>
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.not_now"
                        defaultMessage="Not now"
                    />
                </Button>
            </div>
        </div>
    );
};

const ExtendAction = ({
    connection,
    isExtended,
    onExtend
}: {
    connection: ReconsentConnection;
    isExtended: boolean;
    onExtend: (connection: ReconsentConnection) => void;
}) => {
    if (isExtended) {
        return (
            <Pill variant="green" size="small">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.extended"
                    defaultMessage="Extended"
                />
            </Pill>
        );
    }

    if (!connection.isExtendable) return null;

    return (
        <Button
            variant="primary-rounded"
            size="small"
            onClick={() => onExtend(connection)}
        >
            <FormattedMessage
                id="_.bank_selection_modal.reconsent.extend"
                defaultMessage="Extend"
            />
        </Button>
    );
};
